import React from "react";
import { Typography, Col } from "antd";

const { Title, Text } = Typography;

interface TimeBlockProps {
  label: string;
  value: number;
  amount: string;
  color: string;
}

const TimeBlock: React.FC<TimeBlockProps> = React.memo(
  ({ label, value, amount, color }) => {
    return (
      <Col span={7} style={{ textAlign: "center", padding: "0 4px" }}>
        <Text style={{ fontWeight: 600, fontSize: 16, color }}>{label}</Text>
        <div
          style={{
            width: "100%",
            height: 2,
            backgroundColor: color,
            margin: "4px 0",
          }}
        />
        <Title level={4} style={{ margin: 4, fontSize: 24, color }}>
          {value}
        </Title>
        <Text
          style={{
            fontSize: 12,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {amount}
        </Text>{" "}
      </Col>
    );
  }
);
export default TimeBlock;
